// src/components/common/InfoCard.jsx
import React from "react";

export default function InfoCard({ title, children, icon, iconClass = "" }) {
  return (
    <div
      className="
        group rounded-[24px] p-[1px] 
        bg-gradient-to-b from-[#036AE5]/80 via-[#036AE5]/20 to-white
        transition-all duration-1000 ease-in-out
        hover:bg-gradient-to-t hover:from-[#036AE5]/60 hover:via-[#036AE5]/20 hover:to-white
        hover:-translate-y-2
      "
    >
      <div
        className="
    h-full
    rounded-[22px] bg-[#e8f2fd] backdrop-blur-lg
    p-6 relative overflow-hidden
    transition-colors duration-1000 ease-in-out
    group-hover:bg-[#DFEFFF]
    flex flex-col
  "
      >
        <h4 className="text-neutral-13 text-[24px] font-semibold mobile:text-[16px] tabletpro:text-[20px] tabletair:text-[24px] tabletmini:text-[24px]">
          {title}
        </h4>

        <div className="mt-4 marker:text-xs text-neutral-10 font-normal text-[16px] mobile:text-[14px] tabletpro:text-[14px] tabletair:text-[16px] tabletmini:text-[16px]">
          {children}
        </div>

        {icon && (
          <div className="mt-auto flex justify-end">
            <img
              src={icon}
              alt={`${title} logo`}
              className={`pointer-events-none select-none 
          w-[150px] h-[150px]
          tabletpro:w-[120px] tabletpro:h-[120px] 
          tabletair:w-[160px] tabletair:h-[160px]  
          tabletmini:w-[120px] tabletmini:h-[120px] 
          mobile:w-[80px] mobile:h-[80px] opacity-90
          transition-transform duration-1000 ease-in-out
          ${iconClass}`}
              draggable="false"
            />
          </div>
        )}
      </div>
    </div>
  );
}
